import { Tooltip } from '@mui/material'
import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDELETE_deleteBookmarkMutation, useGET_bookmarksQuery, useGET_resourcesQuery, usePOST_addBookmarkMutation } from 'redux/api/resourcesApi'
import { Bookmark, Close, CloudDownload } from '@mui/icons-material'
import { MAX_PER_PAGE } from 'utils/constants'

const PopupBookmark: FC = () => {
  const { t } = useTranslation()

  
  const [clickedBookmark, setClickedBookmark] = useState(null)
  const [deleteBookmark, {isLoading, isSuccess: deleteBookmarkSuccess}] = useDELETE_deleteBookmarkMutation()

  useEffect(() => {
    if(!isLoading)
        setClickedBookmark(null)
  }, [isLoading])

  const { data: bookmarks } = useGET_bookmarksQuery({page: 1, page_size: MAX_PER_PAGE})
  const { data: resources } = useGET_resourcesQuery({page: 1, page_size: MAX_PER_PAGE})
  
  const bookmarkedRsourceIds = bookmarks?.results?.map(b => b.resource_id ) ?? []

  return (
      <><div style={{ padding: '40px' }}>{
        (resources && bookmarks && resources?.results?.length > 0) 
            && resources.results.filter(r => bookmarkedRsourceIds.includes(r.id)).map(r => 
                       
                <div key={r.id} style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    marginBottom: '20px', 
                    paddingBottom: '20px',
                    borderBottom: '1px dashed gray'}}>
                    <div>
                        <Bookmark 
                            sx={{ cursor: 'pointer', fontSize: '30px', position: 'relative', bottom: '-6px' }} />
                        <span style={{ fontSize: '20px' }}>{r.title}</span>                  
                    </div>
                    <div style={{ paddingLeft: '40px' }}> 
                        {r.attachment && <>
                        <Tooltip title={`${t('common.view')}`} arrow placement='top'>
                            <CloudDownload 
                                sx={{ fontSize: '30px', position: 'relative', bottom: '-6px' }}
                                onClick={() => window.open(r.attachment, '_blank', 'rel=noopener noreferrer')} />
                        </Tooltip>

                        <Tooltip title={`${t('common.remove')}`} arrow placement='top'>
                            <Close
                                sx={{ marginLeft: '10px', cursor: 'pointer', fontSize: '30px', position: 'relative', bottom: '-6px' }}
                                onClick={() => {deleteBookmark(bookmarks?.results?.find(b => b.resource_id === r.id).id)}}
                                />
                        </Tooltip></>}

                    </div>
                </div>
         ) 
      }
      
      {
        (resources && bookmarks && resources?.results?.filter(r => bookmarkedRsourceIds.includes(r.id)).length == 0) 
            && <div style={{ fontSize: '20px', textAlign: 'center'}}> {t('dashboard.no-bookmarks')}</div>
      }
      
      </div>
      
      </>
  )
}

export default PopupBookmark
